import type { Action } from 'vuex'
import type { State, UsersDetailType } from './state'

import actionTypes from './actionTypes'
import { getData, putData, getUsersData } from '@/api/folder_info/folder_info'
import { deepCopy, formatFolderList } from '@/utils'

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_FOLDER_INFO_DETAIL]: async ({ commit, state }): Promise<void> => {
    // フォルダ一覧取得
    const result = await getData()
    const data = [] as any
    if (result.detail.length > 0) {
      result.detail.forEach((item: any) => {
        if (item.display_flag) {
          data.push(item)
        }
      })
    }
    let list2 = JSON.parse(JSON.stringify(result.detail))
    let list = formatFolderList(data)
    if (list.length > 0) {
      list.forEach((item: any) => {
        if (item.folderType == '02') {
          item.children.forEach((item2: any) => {
            if (item2.publicCatrgory == 'N') {
              if (item2.children.length > 0) {
                item2.children.forEach((item3: any) => {
                  item3.associatedStates = true
                  if (item3.children.length > 0) {
                    item3.children.forEach((item4: any) => {
                      item4.associatedStates = true
                      if (item4.children.length > 0) {
                        item4.children.forEach((item5: any) => {
                          item5.associatedStates = true
                        })
                      }
                    })
                  }
                })
              }
            } else {
              if (item2.children.length > 0) {
                item2.children.forEach((item3: any) => {
                  if (item3.publicCatrgory == 'N') {
                    if (item3.children.length > 0) {
                      item3.children.forEach((item4: any) => {
                        item4.associatedStates = true
                        if (item4.children.length > 0) {
                          item4.children.forEach((item5: any) => {
                            item5.associatedStates = true
                          })
                        }
                      })
                    }
                  } else {
                    if (item3.children.length > 0) {
                      item3.children.forEach((item4: any) => {
                        if (item4.publicCatrgory == 'N') {
                          if (item4.children.length > 0) {
                            item4.children.forEach((item5: any) => {
                              item5.associatedStates = true
                            })
                          }
                        }
                      })
                    }
                  }
                })
              }
            }
          })
        }
      })
    }
    commit(actionTypes.SET_FOLDER_INFO_DETAIL, list)
    commit(actionTypes.SET_FOLDER_INFO_DETAIL_SAME, list2)
  },
  [actionTypes.PUT_FOLDER_INFO_DETAIL]: async ({ commit }, val: any): Promise<void> => {
    // フォルダ一覧put/add
    const result = await putData(val)
    const data = result.status
    commit(actionTypes.PUT_FOLDER_INFO_DETAIL, data)
  },

  [actionTypes.SET_FOLDER_INFO_USERS_DETAIL]: async (
    { commit },
    val: number
  ): Promise<void> => {
    // フォルダ一覧put/add
    const result = await getUsersData(val)
    let data = [] as any
    let data2 = [] as any
    if (result.detail.length > 0) {
      result.detail.forEach((item: any) => {
        item.name = item.family_name + '   ' + item.given_name
        if (item.display_in_list) {
          data.push(item)
        } else {
          data2.push(item)
        }
      })
    }
    let list = JSON.parse(JSON.stringify(result.detail))
    let list2 = JSON.parse(JSON.stringify(result.detail))
    commit(actionTypes.SET_FOLDER_INFO_USERS_DETAIL, data)
    commit(actionTypes.SET_FOLDER_INFO_USERS_DETAIL_N, data2)
    commit(actionTypes.SET_FOLDER_INFO_USERS_DETAIL_ALL, list)
    commit(actionTypes.SET_FOLDER_INFO_USERS_DETAIL_ALL_SAME, list2)
  },
  //利用者一覧
  [actionTypes.PUT_FOLDER_INFO_USERS_DETAIL]: ({ commit }, val: any): void => {
    commit(actionTypes.PUT_FOLDER_INFO_USERS_DETAIL, val)
  },
  [actionTypes.DELETE_FOLDER_INFO_USERS_DETAIL]: ({ commit }, val: any): void => {
    commit(actionTypes.DELETE_FOLDER_INFO_USERS_DETAIL, val)
  },
  [actionTypes.SET_FOLDER_INFO_EDIT_USERS_LIST]: ({ commit }, val: any): void => {
    commit(actionTypes.SET_FOLDER_INFO_EDIT_USERS_LIST, val)
  },
  [actionTypes.SET_FOLDER_INFO_USERS_SELECT_LIST]: ({ commit }, val: any): void => {
    commit(actionTypes.SET_FOLDER_INFO_USERS_SELECT_LIST, val)
  },
  [actionTypes.SET_FOLDER_INFO_DETAIL_CHECKED_LIST]: ({ commit }, val: any): void => {
    commit(actionTypes.SET_FOLDER_INFO_DETAIL_CHECKED_LIST, val)
  },

  /** @description 利用者一覧画面表示切替*/
  [actionTypes.SET_MODAL_USER_INFO_ADD_ACTIVED]: ({ commit }, status: boolean) => {
    commit(actionTypes.SET_MODAL_USER_INFO_ADD_ACTIVED, status)
  },

  /** @description 利用者一覧データ初期化*/
  [actionTypes.INIT_USER_INFO_LISTS]: async ({ commit }, folder_id: number): Promise<void> => {
    const result = await getUsersData(folder_id)
    const tempData: Array<UsersDetailType> = deepCopy(result.detail)
    //表示用に変換する
    if (tempData.length > 0) {
      tempData.forEach((item: any) => {
        item.name = item.family_name + '   ' + item.given_name
      })
    }

    const tableData = tempData.filter((userInfo: UsersDetailType) => userInfo.display_in_list)

    //apiから取得する利用者一覧データ
    commit(actionTypes.SET_ORIGIN_USER_INFO_LISTS, result.detail)
    //表示用に変換した利用者一覧データ バックアップ用
    commit(actionTypes.SET_BACKUP_USER_INFO_LISTS, tempData)
    //表示用に変換した利用者一覧データ 表示用
    commit(actionTypes.SET_DISPLAY_USER_INFO_LISTS, tempData)
    //利用者一覧　表示用
    commit(actionTypes.SET_TABLE_USER_INFO_LISTS, tableData)
    //検索欄に入力ある場合、検索結果を表示用利用者一覧データ
    commit(actionTypes.SET_SEARCH_USER_INFO_LISTS, [])
  },

  /** @description apiから取得する利用者一覧データ */
  [actionTypes.SET_ORIGIN_USER_INFO_LISTS]: ({ commit }, data: Array<UsersDetailType>): void => {
    commit(actionTypes.SET_ORIGIN_USER_INFO_LISTS, data)
  },
  /** @description 表示用に変換した利用者一覧データ バックアップ用 */
  [actionTypes.SET_BACKUP_USER_INFO_LISTS]: ({ commit }, data: Array<UsersDetailType>): void => {
    commit(actionTypes.SET_BACKUP_USER_INFO_LISTS, data)
  },
  /** @description 表示用に変換した利用者一覧データ 表示用 */
  [actionTypes.SET_DISPLAY_USER_INFO_LISTS]: ({ commit }, data: Array<UsersDetailType>): void => {
    commit(actionTypes.SET_DISPLAY_USER_INFO_LISTS, data)
  },
  /** @description 利用者一覧　テーブル表示用 */
  [actionTypes.SET_TABLE_USER_INFO_LISTS]: ({ commit }, data: Array<UsersDetailType>): void => {
    commit(actionTypes.SET_TABLE_USER_INFO_LISTS, data)
  },
  /** @description 検索欄に入力ある場合、検索結果を表示用利用者一覧データ */
  [actionTypes.SET_SEARCH_USER_INFO_LISTS]: ({ commit }, data: Array<UsersDetailType>): void => {
    commit(actionTypes.SET_SEARCH_USER_INFO_LISTS, data)
  },
}

export default actions
